import "./Logo.css";

export default function Logo() {
  return (
    <>
      <div className="logo-shape">
        <p className="logo">Date Pal</p>
      </div>
    </>
  );
}
